<template>
  <div class="search-header">
    <div class="back" @click="goBack"></div>
    <div class="header-container">
      <img src="../assets/icons/home/search_icon@2x.png" alt="" />
      <input
        :value="value"
        @input="searchInput"
        @keyup.enter="handleSearch"
        type="text"
        :placeholder="placeholder"
      />
    </div>
    <button @click.stop="handleSearch">
      搜索
    </button>
  </div>
</template>
<script>
export default {
  name: "ml-search-bar",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "搜你想搜看你想看"
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    searchInput(event) {
      this.$emit("update:value", event.target.value);
    },
    handleSearch() {
      this.$emit("handle-search");
    }
  }
};
</script>
<style lang="scss" scoped>
.search-header {
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(225, 225, 230, 1);
  background: #fff;
  width: 100%;
  height: 44px;
  .back {
    width: 40px;
    height: 100%;
    background-image: url("../assets/vip/back_black@2x.png");
    background-size: 9px 14px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .header-container {
    flex: 1;
    display: flex;
    align-items: center;
    width: 290px;
    height: 32px;
    background: rgba(241, 241, 242, 1);
    border-radius: 16px;
    img {
      margin: 0 10px;
      width: 15px;
      height: 15px;
    }
    input {
      width: 80%;
      background: rgba(241, 241, 242, 1);
      font-size: 13px;
      line-height: 18px;
    }
    input::placeholder {
      color: rgba(180, 180, 180, 1);
    }
  }
  button {
    padding: 0 15px;
    border: none;
    font-size: 15px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    background: transparent;
    line-height: 44px;
    text-align: right;
  }
}
</style>
